export const YellowHeader2 = () => {
  return (
    <section className="yellowHeader">
      <h2>Ważne!</h2>
      <p>Wszystkie rzeczy do oddania zapakuj w 60l worki. Dokładną instrukcję jak poprawnie spakować rzeczy znajdziesz TUTAJ.</p>
    </section>
  );
};
